import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  function setLang(lng: "en" | "ms") {
    void i18n.changeLanguage(lng);
  }

  const current = i18n.resolvedLanguage ?? "en";

  return (
    <div className="flex items-center gap-2 text-xs" data-testid="lang-switcher">
      <Languages className="size-4 text-slate-400" />
      <button
        type="button"
        onClick={() => setLang("ms")}
        data-testid="lang-ms"
        className={
          current === "ms"
            ? "text-teal-400 font-semibold"
            : "text-slate-400 hover:text-slate-200"
        }
      >
        BM
      </button>
      <span className="text-slate-700">|</span>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={
          current === "en"
            ? "text-teal-400 font-semibold"
            : "text-slate-400 hover:text-slate-200"
        }
      >
        EN
      </button>
      <span className="sr-only">{t("nav.language")}</span>
    </div>
  );
}
